import Icon from '../components/Icon.vue'

Icon.register({"pen":{"width":512,"height":512,"paths":[{"d":"M290.7 93.2L418.8 221.3 140.8 499.3 26.6 511.9C11.3 513.5-1.6 500.6 0.1 485.3L12.8 371.1 290.7 93.2zM497.9 74.2L437.8 14.1C419.1-4.7 388.7-4.7 369.9 14.1L313.4 70.6 441.4 198.6 497.9 142.1C516.7 123.3 516.7 92.9 497.9 74.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/pen.js
// module id = null
// module chunks = 